import templateUrl from './list-icd-offices-container.component.html';

export const ListIcdOfficesContainerComponent = {
    controller: ListIcdOfficesContainerController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        icdOffices: "<",
        icdCorporationID: "<?icdCorporationId"
    }
};

function ListIcdOfficesContainerController($uibModal, $q, icdOfficeService, utilityService) {
    'ngInject';

    const vm = this;

    vm.icdOffices;
    vm.icdCorporationID;
    vm.filters;
    vm.onChangeFilters = onChangeFilters;
    vm.onDelete = onDelete;
    vm.sortDirection = 1; // Ascending.
    vm.$onInit = onInit;
    vm.saveFilters = saveFilters;
    let defaultFilter = {};

    function onInit() {
        if (vm.isSiteAdmin) {
            defaultFilter = { Role: "Owner" };
        } else {
            defaultFilter = {};
        }

        const filtersRestored = restoreFilters();
        const icdOfficesLoaded = loadICDOffices();

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError($q.all([filtersRestored, icdOfficesLoaded]), "Initial load failed"));
    }

    function loadICDOffices() {
        const query = !vm.filters ? {} : {
            Id: vm.filters.IcdOfficeID,
            OfficeName: vm.filters.OfficeName,
            Inactive: vm.filters.Inactive,
            IcdCorporationID: vm.icdCorporationID,
            IcdCorporationName: vm.filters.IcdCorporationName,
            OfficeCity: vm.filters.OfficeCity,
            OfficeState: vm.filters.OfficeState,
            MoveInDate: vm.filters.MoveInDate,
            MoveOutDate: vm.filters.MoveOutDate
        }

        return icdOfficeService.retrieveIcdOffices(query)
            .then(function (icdOffices) {
                vm.icdOffices = icdOffices;
                utilityService.hideLoading();
            });
    }

    const changeFilters = utilityService.debounce(function () {
        saveFilters();

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(loadICDOffices(), "Filtering failed"));
    }, 500);

    function onChangeFilters(filters) {
        vm.filters = filters;
        changeFilters();
    }

    function saveFilters() {
        localStorage.setItem("listIcdOfficeFilters", JSON.stringify(vm.filters || {}));
    }

    function onDelete(icdoffice) {
        confirmDialog('Are you sure you want to delete this ICD Office?', icdoffice);
    }

    function confirmDialog(message, icdoffice) {
        $uibModal.open({
            template:
                '<div class="modal-body">'
                + message
                + '</div>'
                + '<div class="modal-footer">'
                + '<button class="btn btn-plain float-right" ng-click="vm.close()">No</button>'
                + '<button class="btn btn-plain float-right" ng-click="vm.deleteIcdOffice();">Yes</button>'
                + '</div>',

            controller: function ConfirmModalController($uibModalInstance) {
                this.deleteIcdOffice = function () {
                    icdOfficeService.deleteIcdOffice(icdoffice.Id)
                        .then(function () {
                            return changeFilters();
                        });
                    $uibModalInstance.close();
                };
                this.close = function () {
                    $uibModalInstance.dismiss();
                };
            },
            controllerAs: "vm",
            showCancelButton: true,
            windowClass: 'xx-dialog pagespinner',
            backdrop: 'static'
        }).result.then(function () {
            utilityService.hideLoading();
        });
    }

    function restoreFilters() {
        // Restore filters to the grid from localStorage, if available.
        vm.filters = JSON.parse(localStorage.getItem("listIcdOfficeFilters")) || defaultFilter;

        //Reformat Dates
        if (vm.filters.MoveInDate != null) {
            vm.filters.MoveInDate = new Date(vm.filters.MoveInDate)
        }

        if (vm.filters.MoveOutDate != null) {
            vm.filters.MoveOutDate = new Date(vm.filters.MoveOutDate)
        }

        if (vm.filters == null) {
            vm.filters = {};
            localStorage.setItem("listIcdOfficeFilters", JSON.stringify(vm.filters));
        }
        return $q.when();
    }
}
